<template>
    <div>
        <div class="actions d-flex justify-content-around">
            <b-btn
                v-if="trim.inventoryCount > 0"
                variant="secondary"
                @click="viewListings"
            >
                Shop Listings
                <b-badge pill variant="danger">
                    {{ trim.inventoryCount }}
                </b-badge>
            </b-btn>
            <b-btn variant="orange" @click="buildAndPrice">
                Build &amp; Price
            </b-btn>
        </div>
        <div v-if="inventoryModelCountNationwide > 0" class="pb-4">
            <b-link @click="viewAllListings">
                See All Available {{ trim.make }} {{ trim.model }}
            </b-link>
            <b-badge v-if="selectedLocation" pill variant="danger">
                {{ inventoryModelCountNationwide }}
            </b-badge>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.inv-count {
    font-size: 14px;
    font-weight: bold;
    color: #c0c0c0;
    margin-bottom: 20px;
}
.actions {
    margin: 20px 0;

    button {
        width: 100%;
        max-width: 155px;
        margin: 0 10px;
        position: relative;
        height: 40px;

        &.btn-secondary {
            border: solid 1px $primary-blue;
            color: $primary-blue;
        }
    }

    .badge {
        top: -8px;
        right: 0;
        position: absolute;
        font-family: $helvetica-75-bold;
        font-weight: bold;
    }
}
</style>

<script>
import { get } from "vuex-pathify";

export default {
    props: {
        trim: {
            type: Object,
            required: true
        }
    },

    computed: {
        selectedLocation: get("location/selectedLocation"),
        inventoryModelCountNationwide: get("shopBy/modelCountNationwide")
    },

    methods: {
        viewListings() {
            document.location = `/shop/new?makes=${this.trim.make}&models=${this.trim.model}&trims=${this.trim.trim}&minYear=${this.trim.year}&maxYear=${this.trim.year}&distance=100`;
        },

        viewAllListings() {
            document.location = `/shop/new?distance=-1&stockType=NEW&makes=${this.trim.make}&models=${this.trim.model}&minYear=${this.trim.year}&maxYear=${this.trim.year}`;
        },

        buildAndPrice() {
            document.location = `/configure/style/${this.trim.id}`;
        }
    }
};
</script>
